The type of position profile.

See `PositionProfile` implementations for a list of supported values.
